import { Navigate, useLocation, useParams } from 'react-router-dom';

// The RSVP page used to live at /v2/events/:eventId/rsvp while /events/:eventId/rsvp
// still served the old v1 implementation. Now that RSVPV2 is the only implementation,
// old /v2/... links (already sent in emails, or bookmarked) still need to resolve.
export const V2RsvpRedirect = () => {
    const { eventId } = useParams<{ eventId: string }>();
    const location = useLocation();

    return <Navigate to={{ pathname: `/events/${eventId}/rsvp`, search: location.search }} replace />;
};
